import React from 'react';

const AccessibilityIconBrightnessMinText = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="24" height="24" rx="5" fill="white" />
    <g clip-path="url(#clip0_9254_103084)">
      <path
        d="M18.5042 7.625H14.5958C14.3042 7.625 14.1 7.82917 14.1 8.12083V8.9375C14.1 9.22917 14.3042 9.43333 14.5958 9.43333H18.5333C18.825 9.43333 19.0292 9.22917 19.0292 8.9375V8.12083C19 7.82917 18.7958 7.625 18.5042 7.625Z"
        fill="current"
      />
      <path
        d="M11.3583 7.74167H9.49167L5 17.7167H7.33333L8.325 15.4417H12.5833L13.575 17.7167H15.9375L11.3583 7.74167ZM9.17083 13.4875L10.4542 10.5708L11.7375 13.4875H9.17083Z"
        fill="current"
      />
    </g>
    <defs>
      <clipPath id="clip0_9254_103084">
        <rect width="14" height="14" fill="white" transform="translate(5 5)" />
      </clipPath>
    </defs>
  </svg>
);

export default AccessibilityIconBrightnessMinText;
